import { createEntityAdapter, Dictionary } from '@ngrx/entity'
import { createActionGroup, createFeature, createFeatureSelector, createReducer, emptyProps, on } from '@ngrx/store'
import { userActions } from './user.era'
import {  eventsActions } from './events.era'


export interface Notice {
  id?: string // <== optional because is created by firebase, not here
  is_read: string[],
  createdAt: any, // <== needs to accomodate Date and Timestamp
  createdUid: string,
  firstName: string,
  lastName: string,
  photoURL: string,
  content: string

}

export interface NoticesState {
  ids: string[]
  entities: Dictionary<Notice>,
  noticeList: Notice[],
  isLoading: boolean
}

const initialStateCreator = (): NoticesState => ({
  ids: [],
  entities: {},
  noticeList: [],
  isLoading: true,
})

// Not sure if UID-CreatedAt is sufficient to be unique, but seems like it should be unless createdAt's date is significantly rounded off somehow
export const noticesAdapter = createEntityAdapter<Notice>()

export const noticesActions = createActionGroup({
  source: 'Notices',
  events: {
    'Load Notices': (notices: Notice[]) => ({ notices }),
    'Reset Notices': emptyProps(),
    'Delete Notice': (id: string) => ({ id }),
    'Change Notices Loading Status': (isLoading: boolean) => ({ isLoading })
  }
})  
const getStateWithNoticeList = (state:NoticesState) => {
  state.noticeList = Object.values(state.entities).sort((n1, n2) => n1.createdAt.seconds < n2.createdAt.seconds ? 1 : -1).map(n => ({...n, is_read: [...n.is_read]}))
  return {
    ...state,
    isLoading: false
  }
}

export const noticesReducer = createReducer(
  initialStateCreator(),
  on(noticesActions.loadNotices, (state, { notices }) => {
    const newState = noticesAdapter.upsertMany(notices, state)
    return getStateWithNoticeList(newState)
  }),
  on(noticesActions.deleteNotice, (state, { id }) => {
    const newState = noticesAdapter.removeOne(id, state)
    return getStateWithNoticeList(newState)
  }),
  on(noticesActions.changeNoticesLoadingStatus, (state, { isLoading }) => ({ ...state, isLoading })),
  on(noticesActions.resetNotices, (state) => initialStateCreator()),
  on(userActions.logout, (state) => initialStateCreator()),
  on(eventsActions.unloadEvent, (state) => initialStateCreator())
)

export const noticesFeature = createFeature({
  name: 'notices',
  reducer: noticesReducer
})

export const noticesStateSelector = createFeatureSelector<NoticesState>(noticesFeature.name)

